export default __webpack_public_path__ + "assets/img/under-development-image.af04290e937c9fa86e70f4bd033e95ed.png";